module.exports = __webpack_public_path__ + "98c9878121c0dd7f23e0390e2202dbaf.pdf";